import { useEffect, useRef, useState } from "react";

import { Table, Button, Text } from "@fragments";
import ConfigLoader from "../../components/ConfigLoader";
import Popper from "@fragments/Popper";

import './styles.css'

import api from '@helpers/api'

import { IconCopy, IconDotsVertical, IconPlus, IconSettings, IconTag, IconTrash } from "@tabler/icons-react";

import { useCommunity } from "contexts/community";

import { useParams } from "react-router-dom";

import ManageCouponModal from "@modals/Billing/ManageCouponModal";

export default function Coupons({ info }) {
    const [loading, setLoading] = useState(true)

    let { slug } = useParams();

    const [coupons, setCoupons] = useState([])

    const { loading: communityLoading, community, loadCommunities } = useCommunity();

    const REF_configCouponModal = useRef()

    const popperRef = useRef()


    useEffect(() => {
        if (!communityLoading) handleLoad()
    }, [communityLoading])

    async function handleLoad() {
        setLoading(true)

        try {
            const currentCommunity = community.getBySlug(slug);
            if (currentCommunity?.id) {
                const res = await api.get(`community/${currentCommunity.id}/coupon/list`)
                if (res?.response?.status >= 400) {
                    setCoupons([])
                } else {
                    const raw = res?.data
                    const list = Array.isArray(raw) ? raw : raw?.data ?? []
                    setCoupons([...list])
                }
            }
        } catch (e) {
            console.log(e)
        }

        setLoading(false)
    }

    function handleConfigureCoupon(id) {
        const currentCommunity = community.getBySlug(slug);
        const plan = id ? coupons?.filter(p => p.id === id)[0] : {
            community: currentCommunity.id
        }

        REF_configCouponModal.current.open(plan, async function (result) {
            console.log(result)
            handleLoad()
        })
    }

    function handleDeleteCoupon(coupon) {
        window.openConfirm({
            title: "Deletar cupom",
            headline: "Atenção!",
            subtitle: "Você realmente deseja apagar permanentemente este cupom?",
            buttons: [
                {
                    text: "Apagar permanentemente",
                    onClick: handleExecuteDelete,
                    variant: "contained",
                    className: "",
                    color: "error",
                },
                {
                    text: "Manter cupom",
                    variant: "text",
                },
            ],
        });

        async function handleExecuteDelete() {
            try {
                const body = {
                    duration: {
                        type: coupon?.duration?.type ?? "forever",
                        months:
                            coupon?.duration?.months === undefined || coupon?.duration?.months === null
                                ? null
                                : coupon.duration.months,
                    },
                    code: coupon?.code,
                    percent_off: coupon?.percent_off,
                };
                const res = await api.delete(`community/coupon/${coupon.id}`, body);
                if (res?.response?.status >= 400) {
                    window.setSnackbar(
                        res?.response?.data?.message || "Não foi possível excluir o cupom"
                    );
                    return;
                }
                if (res?.status === 204) {
                    window.setSnackbar("Cupom deletado com sucesso");
                    await handleLoad();
                }
            } catch (e) {
                console.log(e);
            }
        }
    }

    function handleOpenPlanOptions(event, planId) {
        const options = [
            {
                id: 'configure',
                label: 'Configurar',
                icon: <IconSettings size={16} />,
                onClick: async () => {
                    handleConfigureCoupon(planId);
                    popperRef.current.close();
                }
            },
            {
                id: 'delete',
                label: 'Excluir cupom',
                icon: <IconTrash size={16} />,
                variant: 'danger',
                onClick: async () => {
                    const c = coupons.find((x) => x.id === planId);
                    if (c) handleDeleteCoupon(c);
                    popperRef.current.close();
                }
            }
        ];

        popperRef.current.open(options, 'bottom', event.currentTarget);
    }

    function handleCopy(code) {
        const link = `https://pay.ginastee.com/${community.getBySlug(slug).checkout}?coupon=${code}`

        console.log(link)
        navigator.clipboard.writeText(link).then(() => {
            window.setSnackbar("Link copiado");
        }).catch(err => {
            console.error('Erro ao copiar:', err);
            window.setSnackbar("Erro ao copiar o link");
        });
    }

    const columns = [
        {
            field: "code",
            title: "Código",
            grow: 1,
            render: (item) => item.code
        },
        {
            title: "Duração",
            width: "140px",
            align: "center",
            customRender: (item) => {
                const map = {
                    forever: "Para sempre",
                    once: "Uma vez",
                    repeating: `Por ${item.duration?.months} meses`
                };
                return (
                    <Text.span contrast={6}>
                        {map[item.duration?.type] || item.duration?.type || "—"}
                    </Text.span>
                );
            }
        },
        {
            title: "Desconto",
            width: "120px",
            align: "center",
            customRender: (item) => (
                <Text.span contrast={6} weight={500}>
                    {item.percent_off}%
                </Text.span>
            )
        }
    ];

    function CreateCouponButton() {
        return (
            <Button
                onClick={() => handleConfigureCoupon()}
                endIcon={<IconPlus />}
                text="Criar cupom"
            />
        )
    }


    return (
        <div className="config-page config-general-community config-plans-page" key={loading}>
            {(
                <div className="mt-4" key={Math.random()}>
                    <div className="px-3">
                        <Text.h3
                            value="Cupons de desconto"
                            className="mb-2"
                            left={<IconTag />}
                            right={<CreateCouponButton />}
                            grow
                        />
                    </div>

                    <Table
                        id="community-coupons-table"
                        columns={columns}
                        data={coupons}
                        loading={loading}
                        fullWidth
                        actionsComponent={(item) => (
                            <>
                                <Button
                                    color="overlay"
                                    variant="text"
                                    size="medium"
                                    icon={<IconCopy size={16} />}
                                    onClick={() => handleCopy(item.code)}
                                    tooltip="Link do checkout"
                                />
                                <Button
                                    color="overlay"
                                    variant="text"
                                    size="medium"
                                    icon={<IconSettings size={16} />}
                                    onClick={() => handleConfigureCoupon(item.id)}
                                    tooltip="Configurar"
                                />
                                <Button
                                    color="overlay"
                                    variant="text"
                                    size="medium"
                                    icon={<IconDotsVertical size={16} />}
                                    onClick={(event) => handleOpenPlanOptions(event, item.id)}
                                    tooltip="Mais opções"
                                />
                            </>
                        )}
                    />
                </div>
            )}

            <Popper controlRef={popperRef} />

            <ManageCouponModal modalRef={REF_configCouponModal} />
        </div >
    )
}
